package com.example.readingnotes.data.remote.dto

import kotlinx.serialization.Serializable

/**
 * Image data returned in post responses
 */
@Serializable
data class PostImageDto(
    val id: String, // UUID
    val url: String,
    val originalName: String,
    val mimeType: String,
    val width: Int? = null,
    val height: Int? = null,
    val caption: String? = null,
    val altText: String? = null,
    val createdAt: String? = null,
    val updatedAt: String? = null,
    val exifData: com.example.readingnotes.domain.model.ExifData? = null, // Exif metadata
)

/**
 * Full image record data
 */
@Serializable
data class ImageDto(
    val id: String, // UUID
    val objectKey: String,
    val originalName: String,
    val mimeType: String,
    val size: Int,
    val width: Int? = null,
    val height: Int? = null,
    val sha256Hash: String,
    val tenantId: String? = null, // UUID
)

/**
 * Request to generate a presigned upload URL
 */
@Serializable
data class ImageUploadUrlRequestDto(
    val fileName: String,
    val mimeType: String,
    val contentLength: Int,
)

/**
 * Response with presigned upload URL
 */
@Serializable
data class ImageUploadUrlResponseDto(
    val uploadUrl: String,
    val objectKey: String,
    val expiresAt: String,
)

/**
 * Request to confirm image upload
 */
@Serializable
data class ImageConfirmRequestDto(
    val objectKey: String,
)
